import api from "Helpers/Api";
import { TFair } from "Services/Fairs/fairs";

export default async function fairFetch(fairId: string) {
  const { data } = await api.get<TFair>(`/fairs/fetch/${fairId}`);

  return data;
}
